<template>
  <v-row justify="center">
    <v-col style="max-width: 540px !important">
      <v-row no-gutters justify="start" v-if="$store.state.payments.retrieveLoader">
        <v-col cols="12">
          <v-boilerplate type="image, article" />
          <v-skeleton-loader />
        </v-col>
      </v-row>
      <v-card v-else min-width="350">
        <template v-if="payment.account.logo">
          <v-card-title class="py-4 text-center">
            <v-spacer />
            <v-sheet rounded outlined>
              <v-responsive class="align-center" :aspect-ratio="1/1">
                <v-sheet class="px-1" width="100">
                  <v-img :src="payment.account.logo" width="100%" />
                </v-sheet>
              </v-responsive>
            </v-sheet>
            <v-spacer />
          </v-card-title>
          <v-divider />
        </template>
        <v-card-subtitle>
          <v-toolbar class="mx-n2" color="transparent" flat height="18">
            <v-toolbar-items>
              <v-btn @click="$router.push({ name: 'PaymentRetrieve' })" :disabled="loaderPay" text color="primary"><v-icon left>mdi-arrow-left</v-icon>Volver</v-btn>
            </v-toolbar-items>
            <v-toolbar-title class="pl-4">
              <span class="body-1 text--secondary font-weight-medium">{{payment.description}}<v-icon color="secondary">mdi-circle-small</v-icon>{{payment.amount | currency(payment.currency)}} {{payment.currency}}</span>
            </v-toolbar-title>
          </v-toolbar>
        </v-card-subtitle>
        <v-divider />
        <v-card-text class="background">
          <v-row no-gutters align="center" justify="start">
            <v-col cols="12" class="py-1">
              <v-sheet class="px-2 py-3" outlined rounded>
                <div id="card-element"></div>
              </v-sheet>
              <span class="d-block ml-1 mt-4 mb-0 red--text" v-if="gatewayError"><v-icon color="red" left small>mdi-alert</v-icon>{{gatewayError}}</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0 background">
          <v-row align="center" justify="start">
            <v-col cols="12">
              <v-btn @click="pay" :style="{'background-color': `${payment.account.color_background} !important`}" :loading="loaderPay" height="40" block dark>Pagar</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <piriod-sign />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import GatewayViewMixin from '@/mixins/GatewayViewMixin'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import PiriodSign from '@/components/PiriodSign'
export default {
  name: 'piriod-gateway-stripe',
  inject: ['theme'],
  components: {
    PiriodSign,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  mixins: [
    GatewayViewMixin,
    GenericViewMixin
  ],
  data: () => ({
    card: null,
    client: null,
    gatewayError: ''
  }),
  computed: mapState({
    payment: state => cloneDeep(state.payments.payDetail),
    source: state => cloneDeep(state.payments.sourcesDetail),
    paymentsDetail: state => state.payments.paymentsDetail
  }),
  created () {
    this.$store.dispatch('payments/RETRIEVE', {
      resource: 'pay',
      id: this.$route.params.id
    })
    .then(() => {
      if (this.payment.status === 'succeeded' || !this.payment.gateways.includes('stripe')) {
        this.$router.push({ name: 'PaymentRetrieve' })
      }
      this.client = window.Stripe(this.payment.merchants.stripe)
      const elements = this.client.elements({
        locale: 'es'
      })
      this.card = elements.create('card', {
        base: {
          color: this.payment.account.color_background
        }
      })
      this.card.mount('#card-element')
    })
  },
  methods: {
    async pay () {
      try {
        this.gatewayError = ''
        this.loaderPay = true
        await this.createSource('stripe')
        await this.authorizePayment()
        const intent = await this.client.confirmCardPayment(this.source.client.secret, {
          payment_method: {
            card: this.card,
            billing_details: {
              name: this.payment.description
            }
          }
        })
        if (intent.error) {
          this.gatewayError = intent.error.message
        } else if (intent.paymentIntent && intent.paymentIntent.status === 'succeeded') {
          await this.capturePayment()
          this.$router.push({ name: 'PaymentRetrieve' })
        }
      } catch (error) {
        if (error.message) {
          this.gatewayError = error.message
        } else {
          this.gatewayError = error
        }
      } finally {
        this.loaderPay = false
      }
    }
  }
}
</script>